import Select from "../../gui/Select/Select";
import Tabs, { TMenuRow } from "../../gui/Tabs/Tabs";
import { usePath } from "../../libs/path/PathProvider";

const Routes : TMenuRow<string>[] = [
    {text:"Home",id:"/home",url:"/home"},
    {text:"Summary",id:"/summary",url:"/summary"},
    {text:"Fixed",id:"/fixed",url:"/fixed"},
    {text:"Dividends",id:"/dividends",url:"/dividends"},
    {text:"D.History",id:"/divhist",url:"/dhistory"},
    {text:"Calendar",id:"/calendar",url:"/calendar"},
    {text:"Sectors",id:"/sector",url:"/sector"},
    {text:"Tax",id:"/tax",url:"/tax"},
    {text:"History",id:"/history",url:"/history"},
    {text:"Config",id:"/config",url:"/config"},
]

export default function MainTabs(){
    const {path} = usePath();
    const title = (title:TMenuRow<string>) => <></>
    const current = Select.text(Routes.find(p => Select.id(p)==path) || "Home")
    return <header className="flex middle gap-8">
        <div className="logo"/>
        <div className="flex1 align-center w700 title">{current}</div>
        <Tabs options={Routes} breakpoint={800} titleRenderer={title} defaultValue={path}/>
    </header>
}